import router from './router'

export default{
    install(Vue,options)
    {
        Vue.prototype.back = function () {
            window.history.length > 1? router.go(-1): location.href='/'
              // router.push('/');
        };
        Vue.prototype.goUrl = function({url,params,callBack},e){
            e?e.stopPropagation():null;
            e?e.preventDefault():null;
            let data = params||{};
            router.push({path:url,query:data});
            if(callBack){
                callBack()
            }
        };
        /*表单验证*/
        Vue.prototype.FormValida = {
            form_checkUser:function(str){
                let re = /^[\u4e00-\u9fa5_a-zA-Z]+$/;
                if(re.test(str)){
                    return true;
                }else{
                    return false;
                }
            },
            form_checkMobile:function(str){
                let re = /^1\d{10}$/
                if (re.test(str)) {
                    return true;
                } else {
                    return false;
                }
            },
            form_checkTel:function(str){
                let  re = /^0\d{2,3}-?\d{7,8}$/;
                if(re.test(str)){
                    return true;
                }else{
                    return false;
                }
            },
            form_checkEmail:function(str){
                let re = /^(\w-*\.*)+@(\w-?)+(\.\w{2,})+$/
                if(re.test(str)){
                    return true;
                }else{
                    return false;
                }
            },
            form_IdCardNo:function (num2) {
                let num = num2.toUpperCase();
                //身份证号码为15位或者18位，15位时全为数字，18位前17位为数字，最后一位是校验位，可能为数字或字符X。
                if (!(/(^\d{15}$)|(^\d{17}([0-9]|X)$)/.test(num))){
                    alert('输入的身份证号长度不对，或者号码不符合规定！\n15位号码应全为数字，18位号码末位可以为数字或X。');
                    return false;
                }
//校验位按照ISO 7064:1983.MOD 11-2的规定生成，X可以认为是数字10。
//下面分别分析出生日期和校验位
                let len, re;
                len = num.length;
                if (len == 15){
                    re = new RegExp(/^(\d{6})(\d{2})(\d{2})(\d{2})(\d{3})$/);
                    let arrSplit = num.match(re);
//检查生日日期是否正确
                    let dtmBirth = new Date('19' + arrSplit[2] + '/' + arrSplit[3] + '/' + arrSplit[4]);
                    let bGoodDay;
                    bGoodDay = (dtmBirth.getYear() == Number(arrSplit[2])) && ((dtmBirth.getMonth() + 1) == Number(arrSplit[3])) && (dtmBirth.getDate() == Number(arrSplit[4]));
                    if (!bGoodDay) {
                        alert('输入的身份证号里出生日期不对！');
                        return false;
                    }
                    else{
//将15位身份证转成18位
//校验位按照ISO 7064:1983.MOD 11-2的规定生成，X可以认为是数字10。
                        let arrInt = new Array(7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2);
                        let arrCh = new Array('1', '0', 'X', '9', '8', '7', '6', '5', '4', '3', '2');
                        let nTemp = 0, i;
                        num = num.substr(0, 6) + '19' + num.substr(6, num.length - 6);
                        for(i = 0; i < 17; i ++) {
                            nTemp += num.substr(i, 1) * arrInt[i];
                        }
                        num += arrCh[nTemp % 11];
                        return num;
                    }
                }
                if (len == 18){
                    re = new RegExp(/^(\d{6})(\d{4})(\d{2})(\d{2})(\d{3})([0-9]|X)$/);
                    let arrSplit = num.match(re);
//检查生日日期是否正确
                    let dtmBirth = new Date(arrSplit[2] + "/" + arrSplit[3] + "/" + arrSplit[4]);
                    let bGoodDay;
                    bGoodDay = (dtmBirth.getFullYear() == Number(arrSplit[2])) && ((dtmBirth.getMonth() + 1) == Number(arrSplit[3])) && (dtmBirth.getDate() == Number(arrSplit[4]));
                    if (!bGoodDay){
                        alert('输入的身份证号里出生日期不对！');
                        return false;
                    }
                    else{
//检验18位身份证的校验码是否正确。
//校验位按照ISO 7064:1983.MOD 11-2的规定生成，X可以认为是数字10。
                        let valnum;
                        let arrInt = new Array(7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2);
                        let arrCh = new Array('1', '0', 'X', '9', '8', '7', '6', '5', '4', '3', '2');
                        let nTemp = 0, i;
                        for(i = 0; i < 17; i ++){
                            nTemp += num.substr(i, 1) * arrInt[i];
                        }
                        valnum = arrCh[nTemp % 11];
                        if (valnum != num.substr(17, 1)){
                            alert('18位身份证的校验码不正确！应该为：' + valnum);
                            return false;
                        }
                        return num;
                    }
                }
            }
        }
        /*$G() URL */
        Vue.prototype.$G = function(){let Url= top.window.location.href;let u,g,StrBack='';if(arguments[arguments.length-1]=="#"){u=Url.split("#")}else{u=Url.split("?")}if(u.length==1){g=''}else{g=u[1]}if(g!=''){gg=g.split("&");let MaxI=gg.length;str=arguments[0]+"=";for(i=0;i<MaxI;i++){if(gg[i].indexOf(str)==0){StrBack=gg[i].replace(str,"");break}}}return StrBack}
        /*是否为微信浏览器*/
        Vue.prototype.isWeiXin = function(){
            let ua = window.navigator.userAgent.toLowerCase();
            if(ua.match(/MicroMessenger/i) == 'micromessenger'){
                return true;
            }else{
                return false;
            }
        };
        /*获取现在秒级时间戳
        *  __getNowTimestamp();  获取现在的时间戳
        * __getNowTimestamp("2016-05-04");  转时间戳
        * */
        Vue.prototype.__getNowTimestamp = function (t) {
            let date = t ? new Date(t.replace(/-/g,"/")) : new Date();
            let timer = Math.round(date.getTime() / 1000).toString();
            return parseInt(timer)
        };
        /*js秒级时间戳转date
        * __format(stamp,mat)  stamp => 时间戳(选填)  mat => yyyy-MM-dd hh:mm:ss分割符(选填)
        * */
        Vue.prototype.__format = function (stamp,mat) {
            let timeStamp = stamp || __getNowTimestamp();
            let format = mat || "yyyy-MM-dd";
            let thisTime =  new Date(parseInt(timeStamp)*1000);
            let date = {
                "M+": thisTime.getMonth() + 1,
                "d+": thisTime.getDate(),
                "h+": thisTime.getHours(),
                "m+": thisTime.getMinutes(),
                "s+": thisTime.getSeconds(),
                "q+": Math.floor((thisTime.getMonth() + 3) / 3),
                "S+": thisTime.getMilliseconds()
            };
            if (/(y+)/i.test(format)) {
                format = format.replace(RegExp.$1, (thisTime.getFullYear() + '').substr(4 - RegExp.$1.length));
            }
            for (let k in date) {
                if (new RegExp("(" + k + ")").test(format)) {
                    format = format.replace(RegExp.$1, RegExp.$1.length == 1
                        ? date[k] : ("00" + date[k]).substr(("" + date[k]).length));
                }
            }
            return format;
        };
        /*计算天数
        * DateMinus(sDate,eDate) => 必传"2017-05-06"
        * */
        Vue.prototype.DateMinus = function (sDate,eDate){
            let sdate = new Date(sDate.replace(/-/g, "/"));
            let now = new Date(eDate.replace(/-/g, "/"));
            let days = now.getTime() - sdate.getTime();
            let day = parseInt(days / (1000 * 60 * 60 * 24));
            return day;
        };
        /*  计算年龄
             __GetAge(strBirthday) strBirthday => 必传"2017-05-06"
         * */
        Vue.prototype.__GetAge = function(strBirthday){
            let returnAge;
            let strBirthdayArr=strBirthday.split("-");
            let birthYear = strBirthdayArr[0];
            let birthMonth = strBirthdayArr[1];
            let birthDay = strBirthdayArr[2];

            d = new Date();
            let nowYear = d.getFullYear();
            let nowMonth = d.getMonth() + 1;
            let nowDay = d.getDate();

            if(nowYear == birthYear){
                returnAge = 0;//同年 则为0岁
            }
            else{
                let ageDiff = nowYear - birthYear ; //年之差
                if(ageDiff > 0){
                    if(nowMonth == birthMonth) {
                        let dayDiff = nowDay - birthDay;//日之差
                        if(dayDiff < 0)
                        {
                            returnAge = ageDiff - 1;
                        }
                        else
                        {
                            returnAge = ageDiff ;
                        }
                    }
                    else
                    {
                        let monthDiff = nowMonth - birthMonth;//月之差
                        if(monthDiff < 0)
                        {
                            returnAge = ageDiff - 1;
                        }
                        else
                        {
                            returnAge = ageDiff ;
                        }
                    }
                }
                else
                {
                    returnAge = null;//返回null 表示出生日期输入错误 晚于今天
                }
            }

            return returnAge;//返回周岁年龄

        };
        /*设备信息*/
        Vue.prototype.platformFn=function(){let ua=navigator.userAgent.toLowerCase();if(ua.indexOf("window")!=-1){return"windows"}else if(ua.indexOf("ipad")!=-1){return"ipad"}else if(ua.indexOf("ipod")!=-1){return"ipod"}else if(ua.indexOf("iphone")!=-1){return"iphone"}else if(ua.indexOf("mac")!=-1){return"apple"}else if(ua.indexOf("android")!=-1){return"android"}else if(ua.indexOf("linux")!=-1){return"linux"}else if(ua.indexOf("nokia")!=-1){return"nokia"}else if(ua.indexOf("blackberry")!=-1){return"blackberry"}else if(ua.indexOf("freebsd")!=-1){return"freebsd"}else if(ua.indexOf("netbsd")!=-1){return"netbsd"}else if(ua.indexOf("openbsd")!=-1){return"openbsd"}else if(ua.indexOf("opensolaris")!=-1){return"opensolaris"}else if(ua.indexOf("sunos")!=-1){return"sunos"}else if(ua.indexOf("os\/2")!=-1){return"os2"}else if(ua.indexOf("beos")!=-1){return"beos"}else if(ua.indexOf("htc")!=-1){return"htc"}else if(ua.indexOf("windows phone")!=-1){return"windows phone"}else if(ua.indexOf("win")!=-1){return"windows"}};
    },
}



// WEBPACK FOOTER //
// ./src/util.js